products-index
  forms-products-search(tag-scope="forms_products_search")
  products-table(tag-scope="products_table")
  script(type="typescript").
    this.mixin('base');
